/* eslint-disable max-len */
import 'react';

const ImportSuccessSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <circle
                stroke="#5CC58F"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                cx={12}
                cy={12}
                r={10}
            />
            <path
                stroke="#5CC58F"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.3 11.43l3.456 3.614L16.762 9"
            />
        </g>
    </svg>
);

export default ImportSuccessSvg;
